import { useRef, useState } from 'react';
import { Loader2, Upload, Video } from 'lucide-react';
import { toast } from 'sonner';
import { api, message } from '../../lib/api';
import { BLOCKED_FILE_MESSAGE, blockedFailure } from '../../lib/photoSource';

const MAX_BYTES = 40 * 1024 * 1024;
const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

export const VideoUpload = ({ purpose, resourceId, onUpload, id = 'video-upload' }) => {
  const [busy, setBusy] = useState(false);
  const fileInput = useRef(null);
  const cameraInput = useRef(null);

  const send = file => {
    const form = new FormData(); form.append('file', file, file.name || 'video.mp4');
    return api.post('/uploads', form, { params: { purpose, resource_id: resourceId } });
  };
  const choose = async e => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    if (file.size > MAX_BYTES) { toast.error(`Videos must be 40 MB or smaller. This one is ${(file.size / 1048576).toFixed(1)} MB.`); return; }
    setBusy(true);
    try {
      let result;
      try { result = await send(file); }
      catch (first) {
        if (first.response) throw first;
        await wait(500);
        try { result = await send(file); } catch (second) { if (second.response) throw second; throw blockedFailure(second); }
      }
      onUpload(result.data.id);
      toast.success('Video attached');
    } catch (err) {
      toast.error(err.blocked ? BLOCKED_FILE_MESSAGE : (file.size === 0 ? BLOCKED_FILE_MESSAGE : message(err)));
    } finally { setBusy(false); }
  };

  return (
    <div className="photo-upload-controls">
      <input className="photo-file-input" ref={fileInput} data-testid={id} type="file" accept="video/mp4,video/webm" onChange={choose} disabled={busy} aria-label="Attach a video" />
      <button className="photo-action-button" type="button" data-testid={`${id}-button`} disabled={busy} onClick={() => fileInput.current?.click()}>{busy ? <Loader2 size={15} className="animate-spin" /> : <Upload size={15} />}{busy ? 'Uploading…' : 'Attach video'}</button>
      <input className="photo-file-input" ref={cameraInput} data-testid={`${id}-camera`} type="file" accept="video/*" capture="environment" onChange={choose} disabled={busy} aria-label="Record a video with your camera" />
      <button className="photo-action-button" type="button" data-testid={`${id}-camera-button`} disabled={busy} onClick={() => cameraInput.current?.click()}><Video size={15} />Record video</button>
    </div>
  );
};
